



































































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { isMobile } from 'mobile-device-detect'
import UiSelect from '@/components/ui/UiSelect.vue'
import UiLabel from '@/components/ui/UiLabel.vue'
import { masks } from '@/utils/plugins/inputMask'
import { getDays, getMonths, getYears, IDateListItem } from '@/components/ui/UiDatePickerInline/dateFactory'
import { TranslateResult } from 'vue-i18n'

interface Data {
  days: IDateListItem[]
  currentDay: number
  months: IDateListItem[]
  currentMonth: number
  years: IDateListItem[]
  currentYear: number
  isMobile: boolean
  mobilePickerDate: string
}

interface Methods {
  onSelectDay: (e: number) => void
  onSelectMonth: (e: number) => void
  onSelectYear: (e: number) => void
  onMobileSelect: (e: any) => void
  onSelect: () => void
  onFocus: () => void
  onInputDay: (e: string) => void
  onInputMonth: (e: string) => void
  onInputYear: (e: string) => void
}

interface Computed {
  stringDate: string
}

interface Props {
  date: string
  error: boolean
  disabled: boolean
  mobileLabel: string
  dayLabel: string | TranslateResult
  monthLabel: string | TranslateResult
  yearLabel: string | TranslateResult
}

export default Vue.extend({
  name: 'UiDatePickerInline',
  components: {
    UiSelect,
    UiLabel
  },
  model: {
    prop: 'date',
    event: 'select'
  },
  props: {
    date: {
      type: [Date, String],
      default: ''
    },
    error: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    mobileLabel: {
      type: String,
      default: () => ''
    },
    dayLabel: {
      type: String,
      default: function () {
        return this.$t('ui.inlineDatePicker.selectDay')
      }
    },
    monthLabel: {
      type: String,
      default: function () {
        return this.$t('ui.inlineDatePicker.selectMonth')
      }
    },
    yearLabel: {
      type: String,
      default: function () {
        return this.$t('ui.inlineDatePicker.selectYear')
      }
    }
  },
  data () {
    return {
      masks,
      isMobile,
      days: getDays(),
      currentDay: 0,
      months: getMonths(),
      currentMonth: -1,
      years: getYears(),
      currentYear: 0,
      mobilePickerDate: ''
    }
  },
  computed: {
    stringDate () {
      return this.mobilePickerDate ? new Date(this.mobilePickerDate).toLocaleDateString() : ''
    }
  },
  watch: {
    date: {
      handler (value) {
        const date = new Date(value)
        if (!value) {
          this.currentDay = 0
          this.currentMonth = -1
          this.currentYear = 0
          this.mobilePickerDate = ''
          return
        }
        if (value) {
          this.currentDay = date.getDate()
          this.currentMonth = date.getMonth()
          this.currentYear = date.getFullYear()
          this.mobilePickerDate = date.toISOString().slice(0, 10)
        }
      },
      immediate: true
    }
  },
  methods: {
    onSelectDay (e: number) {
      this.currentDay = e
      this.onSelect()
    },
    onSelectMonth (e: number) {
      this.currentMonth = e
      this.days = getDays(this.currentYear, e)

      if (this.currentDay > this.days.length) this.currentDay = this.days.length
      this.onSelect()
    },
    onSelectYear (e: number) {
      this.currentYear = e
      this.days = getDays(e, this.currentMonth)

      if (this.currentDay > this.days.length) this.currentDay = this.days.length
      this.onSelect()
    },
    onMobileSelect (e: any) {
      this.$emit('select', new Date(e.target.value))
    },
    onSelect () {
      if (this.currentYear && this.currentMonth >= 0 && this.currentDay) {
        this.$emit('select',
          new Date(
            Date.UTC(this.currentYear,
              this.currentMonth,
              this.currentDay
            )
          )
        )
      }
    },
    onFocus () {
      this.days = getDays(this.currentYear, this.currentMonth)
      this.months = getMonths()
      this.years = getYears()
    },
    onInputDay (e: string = '') {
      this.days = getDays(this.currentYear, this.currentMonth).filter(day => day.label.includes(e))
    },
    onInputMonth (e: string = '') {
      this.months = getMonths().filter(month => month.label.toLowerCase().includes(e.toLowerCase()))
    },
    onInputYear (e: string = '') {
      this.years = getYears().filter(year => year.label.includes(e))
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
